import * as Actions from "./actions";
import * as Blocks from "./plugins/questionnaires/actions/Blocks";
import * as Domains from "./plugins/reports/actions/Domains";
import * as Questionnaires from "./plugins/questionnaires/actions/Questionnaires";
import * as Questions from "./plugins/questionnaires/actions/Questions";
import * as Options from "./plugins/questionnaires/actions/Answers";
import * as Documents from "./plugins/questionnaires/actions/Documents";
import * as Surveys from "./plugins/questionnaires/actions/Surveys";
import * as Organizations from "./plugins/questionnaires/actions/Organizations";
import * as Roles from "./actions/Roles";
import * as Users from "./actions/Users";
import Configuration from "./config";
import { Cache } from "./storage";

const appStore = (
	state = {
		// Basis
		environment: "",
		historyRoute: null,
		isFetching: 0,
		jwt: null,
		messages: [],
		route: null,
		show: null,
		title: null,
		user: null,
		
		// Allgemeine Module
		articles: Cache.load( "articles", [] ),
		documents: Cache.load( "documents", [] ),
		fieldOptions: Cache.load( "fieldOptions", [] ),
		organizations: Cache.load( "organizations", [] ),
		permissions: Cache.load( "permissions", [] ),
		roles: Cache.load( "roles", [] ),
		users: Cache.load( "users", [] ),
		userCount: Cache.load( "userCount" )
	},
	action
) =>
{
	if ( Configuration.pluginName === "reports" )
	{
		state[ "domains" ] = state.domains ? state.domains : Cache.load( "domains", [] );
	}
	
	if ( Configuration.pluginName === "questionnaires" )
	{
		state[ "blocksByQuestionnaireId" ] = state.blocksByQuestionnaireId ? state.blocksByQuestionnaireId : Cache.load( "blocksByQuestionnaireId", [] );
		state[ "documentsByQuestionnaireId" ] = state.documentsByQuestionnaireId ? state.documentsByQuestionnaireId : Cache.load( "documentsByQuestionnaireId", [] );
		state[ "questionnairesOverview" ] = state.questionnairesOverview ? state.questionnairesOverview : Cache.load( "questionnairesOverview", [] );
		state[ "nextSurveyQuestion" ] = state.nextSurveyQuestion ? state.nextSurveyQuestion : Cache.load( "nextSurveyQuestion" );
		state[ "orderableQuestionnaires" ] = state.orderableQuestionnaires ? state.orderableQuestionnaires : Cache.load( "orderableQuestionnaires", [] );
		state[ "questionnaires" ] = state.questionnaires ? state.questionnaires : Cache.load( "questionnaires", [] );
		state[ "questions" ] = state.questions ? state.questions : Cache.load( "questions", [] );
		state[ "createdTreeKey" ] = state.createdTreeKey ? state.createdTreeKey : null;
		state[ "surveys" ] = state.surveys ? state.surveys : Cache.load( "surveys", [] );
		state[ "surveyAnswers" ] = state.surveyAnswers ? state.surveyAnswers : Cache.load( "surveyAnswers", [] );
		
		// @deprecatede
		state[ "nextBlockSortId" ] = state.nextBlockSortId ? state.nextBlockSortId : null;
		state[ "nextQuestionSortId" ] = state.nextQuestionSortId ? state.nextQuestionSortId : null;
	}
	
	switch ( action.type )
	{
		case Actions.SET_CREATED_TREE_KEY:
			return Object.assign(
				{},
				state,
				{
					createdTreeKey: action.value
				}
			);
		
		case Actions.SET_SHOW:
			return Object.assign(
				{},
				state,
				{
					show: action.value
				}
			);
		
		case Actions.SET_TITLE:
			return Object.assign(
				{},
				state,
				{
					title: action.value
				}
			);
		
		case Actions.MESSAGE:
			if ( action.uniqueByMessage && state.messages.find( message => message.message === action.message.message ) )
			{
				return state;
			}
			
			return Object.assign(
				{},
				state,
				{
					messages: [].concat( action.message, state.messages )
				}
			);
		
		case Actions.REFRESH_MESSAGES:
			return Object.assign(
				{},
				state,
				{
					messages: state.messages.filter( ( message ) => !message.timeout || message.timeout > ( +new Date() ) )
				}
			);
		
		case Actions.REMOVE_MESSAGE:
			return Object.assign(
				{},
				state,
				{
					messages: state.messages.filter( ( message ) => message.id !== action.id )
				}
			);
		
		case Actions.SET_IS_FETCHING:
			return Object.assign(
				{},
				state,
				{
					isFetching: action.value ? state.isFetching + 1 : state.isFetching - 1
				}
			);
		
		case Actions.SET_ROUTE:
			return Object.assign(
				{},
				state,
				{
					route: action.route
				}
			);
		
		case Actions.SET_HISTORY_ROUTE:
			return Object.assign(
				{},
				state,
				{
					historyRoute: action.route
				}
			);
		
		case Questionnaires.SET_QUESTIONNAIRES_OVERVIEW:
			Cache.save( "questionnairesOverview", action.json );
			return Object.assign(
				{},
				state,
				{
					questionnairesOverview: action.json
				}
			);
		
		case Questionnaires.SET_ORDERABLE_QUESTIONNAIRES:
			Cache.save( "orderableQuestionnaires", action.json );
			return Object.assign(
				{},
				state,
				{
					orderableQuestionnaires: action.json
				}
			);
		
		case Questionnaires.SET_QUESTIONNAIRE_ID:
			return Object.assign(
				{},
				state,
				{
					id: action.json
				}
			);
		
		case Questionnaires.SET_INITIAL_QUESTIONNAIRES:
			Cache.save( "questionnaires", action.json );
			return Object.assign(
				{},
				state,
				{
					questionnaires: action.json
				}
			);
		
		case Questionnaires.SET_QUESTIONNAIRES:
			const questionnaires = Object.assign(
				{},
				state.questionnaires,
				{
					[ action.json.id ]: action.json
				}
			);
			Cache.save( "questionnaires", questionnaires );
			return Object.assign(
				{},
				state,
				{
					questionnaires: questionnaires
				}
			);
		
		case Blocks.SET_BLOCKS:
			const blocksByQuestionnaireId = Object.assign(
				{},
				state.blocksByQuestionnaireId,
				{
					[ action.questionnaire_id ]: action.json
				}
			);
			Cache.save( "blocksByQuestionnaireId", blocksByQuestionnaireId );
			return Object.assign(
				{},
				state,
				{
					blocksByQuestionnaireId: blocksByQuestionnaireId
				}
			);
		
		case Blocks.SET_NEXT_BLOCK_SORT_ID:
			return Object.assign(
				{},
				state,
				{
					nextBlockSortId: action.sort_id
				}
			);
		
		case Blocks.RESET_BLOCKS:
			Cache.save( "blocksByQuestionnaireId", action.json );
			return Object.assign(
				{},
				state,
				{
					blocksByQuestionnaireId: action.json
				}
			);
		
		case Questions.SET_QUESTIONS:
			const questions = Object.assign(
				{},
				state.questions,
				action.json
			);
			Cache.save( "questions", questions );
			return Object.assign(
				{},
				state,
				{
					questions: questions
				}
			);
		
		case Questions.SET_NEXT_QUESTION_SORT_ID:
			return Object.assign(
				{},
				state,
				{
					nextQuestionSortId: Object.assign(
						{},
						state.nextQuestionSortId,
						{
							[ action.block_id ]: action.sort_id
						}
					)
				}
			);
		
		case Questions.SET_BLOCK_QUESTIONS:
			const newBlockQuestions = Object.assign(
				{},
				state.blocksByQuestionnaireId,
				{
					[ action.questionnaire_id ]: Object.assign(
						{},
						state.blocksByQuestionnaireId[ action.questionnaire_id ],
						{
							[ action.block_id ]: Object.assign(
								{},
								state.blocksByQuestionnaireId[ action.questionnaire_id ][ action.block_id ],
								{
									"questions": action.json
								}
							)
						}
					)
				}
			);
			Cache.save( "blocksByQuestionnaireId", newBlockQuestions );
			return Object.assign(
				{},
				state,
				{
					blocksByQuestionnaireId: newBlockQuestions
				}
			);
		
		case Options.SET_QUESTION_ANSWERS:
			const newQuestionAnswers = Object.assign(
				{},
				state.questions,
				{
					[ action.questionnaire_id ]: Object.assign(
						{},
						state.questions[ action.questionnaire_id ],
						{
							[ action.question_id ]: Object.assign(
								{},
								state.questions[ action.questionnaire_id ][ action.question_id ],
								{
									"answers": action.json
								}
							)
						}
					)
				}
			);
			Cache.save( "questions", newQuestionAnswers );
			return Object.assign(
				{},
				state,
				{
					questions: newQuestionAnswers
				}
			);
		
		case Options.SET_BLOCK_QUESTIONS_ANSWERS:
			const newBlockQuestionAnswers = Object.assign(
				{},
				state.blocksByQuestionnaireId,
				{
					[ action.questionnaire_id ]: Object.assign(
						{},
						state.blocksByQuestionnaireId[ action.questionnaire_id ],
						{
							[ action.block_id ]: Object.assign(
								{},
								state.blocksByQuestionnaireId[ action.questionnaire_id ][ action.block_id ],
								{
									"questions": Object.assign(
										{},
										state.blocksByQuestionnaireId[ action.questionnaire_id ][ action.block_id ][ "questions" ],
										{
											[ action.question_id ]: Object.assign(
												{},
												state.blocksByQuestionnaireId[ action.questionnaire_id ][ action.block_id ][ "questions" ][ action.question_id ],
												{
													"answers": action.json
												}
											)
										}
									)
								}
							)
						}
					)
				}
			);
			Cache.save( "blocksByQuestionnaireId", newBlockQuestionAnswers );
			return Object.assign(
				{},
				state,
				{
					blocksByQuestionnaireId: newBlockQuestionAnswers
				}
			);
		
		case Surveys.SET_SURVEYS:
			Cache.save( "surveys", action.json );
			return Object.assign(
				{},
				state,
				{
					surveys: action.json
				}
			);
		
		case Surveys.SET_LAST_SURVEY_ANSWER:
			const surveyAnswers = Object.assign(
				{},
				state.surveyAnswers,
				{
					[ action.json.survey_answer_id ]: action.json
				}
			);
			Cache.save( "surveyAnswers", surveyAnswers );
			return Object.assign(
				{},
				state,
				{
					surveyAnswers: surveyAnswers
				}
			);
		
		case Surveys.SET_LAST_SURVEY_ANSWERS:
			Cache.save( "surveyAnswers", action.json );
			return Object.assign(
				{},
				state,
				{
					surveyAnswers: action.json
				}
			);
		
		case Surveys.RESET_BLOCKS:
			Cache.save( "blocksByQuestionnaireId", action.json );
			return Object.assign(
				{},
				state,
				{
					blocksByQuestionnaireId: action.json
				}
			);
		
		case Surveys.SET_NEXT_SURVEY_QUESTION:
			Cache.save( "nextSurveyQuestion", action.json );
			return Object.assign(
				{},
				state,
				{
					nextSurveyQuestion: action.json
				}
			);
		
		// Documents
		case Documents.SET_DOCUMENTS:
			const documents = Object.assign(
				{},
				state.documents,
				{
					[ action.json.id ]: action.json
				}
			);
			Cache.save( "documents", documents );
			return Object.assign(
				{},
				state,
				{
					documents: documents
				}
			);
		
		case Documents.SET_QUESTIONNAIRE_DOCUMENTS:
			Cache.save( "documentsByQuestionnaireId", action.json );
			return Object.assign(
				{},
				state,
				{
					documentsByQuestionnaireId: action.json
				}
			);
		
		case Organizations.SET_ORGANIZATIONS_OVERVIEW:
			Cache.save( "organizations", action.json );
			return Object.assign(
				{},
				state,
				{
					organizations: action.json
				}
			);
		
		case Roles.SET_ROLES_OVERVIEW:
			Cache.save( "roles", action.json );
			return Object.assign(
				{},
				state,
				{
					roles: action.json
				}
			);
		
		case Roles.SET_PERMISSIONS_OVERVIEW:
			Cache.save( "permissions", action.json );
			return Object.assign(
				{},
				state,
				{
					permissions: action.json
				}
			);
		
		case Users.SET_USER:
			return Object.assign(
				{},
				state,
				{
					user: action.json,
					jwt: action.jwt
				}
			);
		
		case Users.SET_USERS_OVERVIEW:
			Cache.save( "users", action.json );
			return Object.assign(
				{},
				state,
				{
					users: action.json
				}
			);
		
		case Users.SET_ARTICLES:
			Cache.save( "articles", action.json );
			return Object.assign(
				{},
				state,
				{
					articles: action.json
				}
			);
		
		case Users.SET_FIELD_OPTIONS:
			Cache.save( "fieldOptions", action.json );
			return Object.assign(
				{},
				state,
				{
					fieldOptions: action.json
				}
			);
		
		case Users.SET_USERS:
			const users = Object.keys( state.users ).map(
				a_key =>
				{
					let user = state.users[ a_key ];
					if ( action.json.id === user.id )
					{
						user = Object.assign(
							{},
							user,
							action.json
						);
					}
					return user;
				}
			);
			Cache.save( "users", users );
			return Object.assign(
				{},
				state,
				{
					users: users
				}
			);
		
		case Users.SET_USER_COUNT:
			Cache.save( "userCount", action.json );
			return Object.assign(
				{},
				state,
				{
					userCount: action.json
				}
			);
		
		case Users.SET_ORGANIZATION_LIMIT:
			const newOrganizationLimit = Object.assign(
				{},
				state.user,
				{
					"organization": Object.assign(
						{},
						state.user[ "organization" ],
						{
							"monthly_limit": action.json
						}
					)
				}
			);
			Cache.save( "user", newOrganizationLimit );
			return Object.assign(
				{},
				state,
				{
					user: newOrganizationLimit
				}
			);
		
		case Users.SET_SURVEY_COSTS:
			const newSurveyCosts = Object.assign(
				{},
				state.user,
				{
					"organization": Object.assign(
						{},
						state.user[ "organization" ],
						{
							"survey_costs": action.json
						}
					)
				}
			);
			Cache.save( "user", newSurveyCosts );
			return Object.assign(
				{},
				state,
				{
					user: newSurveyCosts
				}
			);
		
		case Users.SET_BASIC_CHARGE:
			const newBasicCharge = Object.assign(
				{},
				state.user,
				{
					"organization": Object.assign(
						{},
						state.user[ "organization" ],
						{
							"basic_charge": action.json
						}
					)
				}
			);
			Cache.save( "user", newBasicCharge );
			return Object.assign(
				{},
				state,
				{
					user: newBasicCharge
				}
			);
		
		case Domains.SET_DOMAINS:
			Cache.save( "domains", action.json );
			return Object.assign(
				{},
				state,
				{
					domains: action.json
				}
			);
		
		default:
			return state;
	}
};

export default appStore;